<template>
  <tr :class="{'is-marked': marked}">
    <td class="text-center">
      <DamageRating
        :is-exo-user="policyUpdate"
        :has-revision="hasRevision"
        :inspectionRating="rating"
        :inspectionOverride="override"
        :remediation="remediation"
        :client-remediated-rating="clientRemediatedRating"
        :remediation-preview-rating="remediationPreviewRating"
        :show-in-preview-mode="showInPreviewMode"
      />
    </td>

    <td
      v-if="showFindingNameColumn"
    >
      <DetailsButton
        title="Finding Details"
        entity-type="findingDetails"
        :entity="id"
        :args="{showInPreviewMode: this.showInPreviewMode, canViewFindingTypeDetails: this.canViewFindingTypeDetails}"
      >
        <a
          :href="findingUrl"
          title="Finding"
        >{{displayName}}</a>
      </DetailsButton>
    </td>

    <td>
      <template v-if="showFindingNameColumn">
        <template v-if="canViewFindingTypeDetails">
          <a
            :href="findingTypeUrl"
            title="Finding"
          >{{findingType.name}}</a>
        </template>
        <template v-else>
          {{findingType.name}}
        </template>
      </template>
      <template v-else>
        <DetailsButton
          title="Finding Details"
          entity-type="findingDetailsSimple"
          :entity="id"
          :args="{showEntityDetailsActions: this.showFindingNameColumn}"
        >
          {{findingType.name}}
        </DetailsButton>
      </template>
    </td>

    <td class="text-end">
      {{ h$.formatDate.short(inspection.date) }}
    </td>

    <transition name="status-change" mode="out-in">
      <td 
        v-if="showStatus" 
        :key="status" 
        class="text-center"
      >
        <span :class="'item-status-' + status">{{status}}</span>
      </td>
    </transition>

    <td class="text-center">
      <span
        v-if="photoCount > 0"
        class="indicator-images"
        title="Finding Photos" 
        data-action="show-details" 
        data-entity-type="findingPhotos"
        :data-entity="id"
        :data-row="rowRef"
      ></span>
    </td>

    <td class="table-row-actions">
      <RowAction
        :href="findingUrl"
        action="read"
      />

      <RowAction
        v-if="policyUpdate"
        :href="findingUrl + '/edit'"
        action="update"
      />

      <RowAction
        v-if="policyUpdate"
        :href="findingUrl"
        action="delete"
      />
    </td>
  </tr>
</template>

<script>
import helpers from "../../helpers.js";

import Row from "../shared/grid/row";
import RowAction from "../shared/grid/row_action";
import DetailsButton from "../shared/grid/details_button";
import DamageRating from "../shared/damage_rating";

export default {
  extends: Row,

  components: {
    RowAction,
    DamageRating,
    DetailsButton
  },

  props: {
    id: String,
    rating: Number,
    clientRating: Number,
    remediatedRating: Number,
    clientRemediatedRating: Number,
    remediationPreviewRating: Number,
    displayName: String,
    component: Object,
    status: String,
    showStatus: Boolean,
    inspection: Object,
    photoCount: Number,
    findingType: Object,
    showFindingNameColumn: Boolean,
    remediation: Object,
    override: Object,
    hasRevision: Boolean,
    policyUpdate: Boolean,
    showInPreviewMode: Boolean
  },

  setup () {
    return {
      h$: helpers
    }
  },

  computed: {
    findingUrl: function () {
      return "/findings/" + this.id
    },

    findingTypeUrl: function () {
      return "/finding_types/" + this.findingType.id
    },

    canViewFindingTypeDetails: function () {
      return this.policyUpdate && this.showFindingNameColumn
    },
  }
}
</script>
